import { render } from "./action-text.vue?vue&type=template&id=1effd4d0&scoped=true"
import script from "./action-text.js?vue&type=script&lang=js&external"
export * from "./action-text.js?vue&type=script&lang=js&external"

import "./action-text.scss?vue&type=style&index=0&id=1effd4d0&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1effd4d0"]])

export default __exports__